/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * VSD API
 * API for the Victim Services Directory (VSD) application
 * OpenAPI spec version: v1
 */

export interface Lineitem {
  /** @nullable */
  attendingSupportPerson?: string;
  /** @nullable */
  counsellingType?: number;
  /** @nullable */
  counsellingTypeName?: string;
  /** @nullable */
  missedSession?: boolean;
  /** @nullable */
  sessionAmount?: number;
  /** @nullable */
  sessionDate?: string;
  /** @nullable */
  sessionHours?: number;
}
